import { oauthRequest, oauthReceive } from '../../actions/Api';
import { appErrorAction } from '../../actions/App';
import { callApiPost, getBasicAuth } from './common';
import { OAUTH_ENDPOINT } from '../../constants/Api';

/**
 * Determines if the state allows us to run updates.
 * @param  {object} state The current state.
 * @return {boolean}      If we can update or not.
 */
const shouldFetch = (state) => {
  let isTokenValid = false;
  if (state.userData.token && state.userData.token.received && state.userData.token.expires_in) {
    isTokenValid =
    ((Date.now() - state.userData.token.received) < (state.userData.token.expires_in * 1000));
  }

  if (state.userData.isFetchingOauth) {
    return false;
  } else if (isTokenValid) {
    return false;
  }

  // Check if we have data to fetch.
  if (Object.keys(state.section.packageData).length === 0) {
    return false;
  }
  return true;
};

/**
 * Fetches package data and validates it.
 * @return {function} Dispatch function.
 */
const callOauth = (grantType, clientId, clientSecret) => {
  return dispatch => {
    dispatch(oauthRequest());
    const url = OAUTH_ENDPOINT;
    const payload = {
      grant_type: grantType,
      client_id: clientId,
      client_secret: clientSecret,
    };
    return callApiPost(url, payload, dispatch, false, true, false)
      .then(data => dispatch(oauthReceive(data)))
      .catch(data => dispatch(appErrorAction(data)));
  };
};

/**
 * Call the create service.
 * @return {Promise}           The promise of the service.
 */
export const requestCredentials = (basicOnly = false) => {
  return (dispatch, getState) => {
    const state = getState();

    // If we only need basic auth we find that and return it.
    if (basicOnly) {
      const basicAuth = getBasicAuth(state);
      const credentials = {
        basicAuth,
      };
      return Promise.resolve(credentials);
    }

    if (shouldFetch(state)) {
      // Get the auth info from the state.
      const {
        section: {
          packageData: {
            credentials: {
              oauth: {
                grant_type,    /* eslint-disable-line */
                client_id,     /* eslint-disable-line */
                client_secret, /* eslint-disable-line */
              },
            },
          },
        },
      } = state;

      return dispatch(callOauth(grant_type, client_id, client_secret)).then(() => {
        const newState = getState();
        const { userData: { token } } = newState;
        const basicAuth = getBasicAuth(newState);
        const credentials = {
          token,
          basicAuth,
        };
        return credentials;
      });
    }

    // Let the calling code know there's nothing to wait for and return the token.
    if (state.userData.token) {
      const { userData: { token } } = state;
      const basicAuth = getBasicAuth(state);
      const credentials = {
        token,
        basicAuth,
      };
      return Promise.resolve(credentials);
    }
    return Promise.resolve();
  };
};



// WEBPACK FOOTER //
// ./src/utilities/api/auth.js